import {FormControl} from "@angular/forms";

export interface IOrder {
  id: number;
  parent_id: number;
  number: string;
  order_key: string;
  created_via: string;
  version: string;
  status: string;
  currency: string;
  currency_symbol: string;
  payment_status?: string;
  customer?: ICustomer;
  customer_data?: ICustomer;
  date_created: string;
  date_created_gmt: string;
  date_modified: string;
  date_modified_gmt: string;
  discount_total: string;
  discount_tax: string;
  shipping_total: string;
  shipping_tax: string;
  cart_tax: string;
  total: string;
  total_tax: string;
  prices_include_tax: boolean;
  customer_id: number;
  customer_ip_address: string;
  customer_user_agent: string;
  customer_note: string;
  billing: {
    first_name: string;
    last_name: string;
    company: string;
    address_1: string;
    address_2: string;
    city: string;
    state: string;
    postcode: string;
    country: string;
    email: string;
    phone: string;
  };
  shipping: {
    first_name: string;
    last_name: string;
    company: string;
    address_1: string;
    address_2: string;
    city: string;
    state: string;
    postcode: string;
    country: string;
  };
  payment_method: string;
  payment_method_title: string;
  transaction_id: string;
  date_paid: string;
  date_paid_gmt: string;
  date_completed: any;
  date_completed_gmt: any;
  cart_hash: string;
  meta_data: Array<{
    id: number;
    key: string;
    value: string;
  }>;
  line_items: Array<IOrderedProduct>;
  tax_lines: Array<{
    id: number;
    rate_code: string;
    rate_id: number;
    label: string;
    compound: boolean
    tax_total: string;
    shipping_tax_total: string;
    meta_data: Array<any>
  }>;
  shipping_lines: Array<{
    id: number;
    method_title: string;
    method_id: string;
    total: string;
    total_tax: string;
    taxes: Array<any>
    meta_data: Array<any>
  }>;
  fee_lines: Array<any>;
  coupon_lines: Array<any>;
  refunds: Array<any>;
  _links: {
    self: Array<{
      href: string;
    }>
    collection: Array<{
      href: string;
    }>
  };
  hasTestEnvironment?: boolean;
}

export interface IOrderedProduct {
  id: number;
  name: string;
  image: { id: number, src: string };
  parent_name: string;
  product_id: number;
  variation_id: number;
  quantity: number;
  tax_class: string;
  subtotal: string;
  subtotal_tax: string;
  total: string;
  total_tax: string;
  taxes: Array<{
    id: number;
    total: string;
    subtotal: string;
  }>;
  meta_data: Array<{
    id: number;
    key: string;
    value: string;
    display_key: string;
    display_value: string;
  }>;
  sku: string;
  price: number;
  selected?: boolean;
  refund_details?: any;
  refundQuantity?: FormControl
}

export interface IOrdersParams {
  websiteId: number;
  status: string;
  page: number;
  per_page: number;
  search?: string;
}

export interface ICustomersParams {
  websiteId: number;
  page: number;
  per_page: number;
  search?: string;
  searchby?: string;
}

export enum OrderStatusEnum {
  PENDING = "pending",
  PROCESSING = "processing",
  ON_HOLD = "on-hold",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  REFUNDED = "refunded",
  FAILED = "failed",
  TRASH = "trash",
  DRAFT = "checkout-draft"
}

export enum PaymentStatusEnum {
  "pending" = "pending",
  "processing" = "paid",
  "on-hold" = "on hold",
  "completed" = "paid",
  "cancelled" = "cancelled",
  "refunded" = "refunded",
  "failed" = "failed",
  "checkout-draft" = "draft",
  TRASH = "trash"
}

interface ICustomer {
  id: number;
  customer_id?: string;
  date_created: string;
  date_created_gmt: string;
  date_modified: string;
  date_modified_gmt: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  username: string;
  billing: {
    first_name: string;
    last_name: string;
    company: string;
    address_1: string;
    address_2: string;
    city: string;
    postcode: string;
    country: string;
    state: string;
    email: string;
    phone: string;
  };
  shipping: {
    first_name: string;
    last_name: string;
    company: string;
    address_1: string;
    address_2: string;
    city: string;
    postcode: string;
    country: string;
    state: string;
    phone: string;
  };
  is_paying_customer: boolean;
  avatar_url: string;
  _links: {
    self: Array<{
      href: string;
    }>
    collection: Array<{
      href: string;
    }>
  };
}
